// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pedia-content .title {
  margin-top: calc(30 * var(--width-ratio));
}
.pedia-content .excerpt {
  padding-bottom: calc(12 / var(--base-width) * 100vw);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/pedia-post-list/pedia-post-list.component.scss"],"names":[],"mappings":"AACE;EACE,yCAAA;AAAJ;AAEE;EACE,oDAAA;AAAJ","sourcesContent":[".pedia-content {\n  .title {\n    margin-top: calc(30 * var(--width-ratio));\n  }\n  .excerpt {\n    padding-bottom: calc(12 / var(--base-width) * 100vw);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
